import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Typography,
  Grid,
  Card,
  CardContent,
  CardHeader,
  CardActions,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Alert,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemSecondaryAction,
  Divider,
  Tooltip,
  Switch,
  FormControlLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  LinearProgress,
  Snackbar,
  Breadcrumbs,
  Link,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Badge,
  Avatar,
  Rating,
  AlertTitle,
  Drawer,
  AppBar,
  Toolbar,
  Tabs,
  Tab,
  ListItemButton,
  ListItemAvatar,
  CardMedia,
  Checkbox,
  Radio,
  RadioGroup,
  Slider,
  FormGroup,
  FormLabel,
  FormHelperText,
  Autocomplete,
} from '@mui/material';
import {
  Add,
  Edit,
  Delete,
  Save,
  Cancel,
  Visibility,
  Archive,
  Unarchive,
  Search,
  FilterList,
  Sort,
  Refresh,
  ExpandMore,
  Close,
  ArrowBack,
  ArrowForward,
  FirstPage,
  LastPage,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  Notifications,
  Settings,
  Help,
  ContactSupport,
  History,
  Assessment,
  Analytics,
  Timeline,
  Receipt,
  Payment,
  AccountBalance,
  QrCode,
  Description,
  Schedule,
  LocalShipping,
  AttachMoney,
  AccountBalanceWallet,
  Security,
  Verified,
  Lock,
  Visibility as VisibilityIcon,
  VisibilityOff,
  Print,
  Download,
  Share,
  Email,
  Phone,
  Business,
  Person,
  LocationOn,
  CalendarToday,
  AccessTime,
  TrendingUp,
  TrendingDown,
  CheckCircle,
  Error,
  Warning,
  Info,
  Build,
  Engineering,
  Speed,
  Timer,
  Work,
  Assignment,
  Inventory,
  ProductionQuantityLimits,
  Category,
  Palette,
  Straighten,
  Scale,
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Save as SaveIcon,
  Cancel as CancelIcon,
  Visibility as VisibilityIcon2,
  Archive as ArchiveIcon,
  Unarchive as UnarchiveIcon,
  Search as SearchIcon,
  FilterList as FilterListIcon,
  Sort as SortIcon,
  Refresh as RefreshIcon,
  ExpandMore as ExpandMoreIcon,
  Close as CloseIcon,
  ArrowBack as ArrowBackIcon,
  ArrowForward as ArrowForwardIcon,
  FirstPage as FirstPageIcon,
  LastPage as LastPageIcon,
  KeyboardArrowLeft as KeyboardArrowLeftIcon,
  KeyboardArrowRight as KeyboardArrowRightIcon,
  Notifications as NotificationsIcon,
  Settings as SettingsIcon,
  Help as HelpIcon,
  ContactSupport as ContactSupportIcon,
  History as HistoryIcon,
  Assessment as AssessmentIcon,
  Analytics as AnalyticsIcon,
  Timeline as TimelineIcon,
  Receipt as ReceiptIcon,
  Payment as PaymentIcon,
  AccountBalance as AccountBalanceIcon,
  QrCode as QrCodeIcon,
  Description as DescriptionIcon,
  Schedule as ScheduleIcon,
  LocalShipping as LocalShippingIcon,
  AttachMoney as AttachMoneyIcon,
  AccountBalanceWallet as AccountBalanceWalletIcon,
  Security as SecurityIcon,
  Verified as VerifiedIcon,
  Lock as LockIcon,
  VisibilityOff as VisibilityOffIcon,
  Print as PrintIcon,
  Download as DownloadIcon,
  Share as ShareIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  Business as BusinessIcon,
  Person as PersonIcon,
  LocationOn as LocationOnIcon,
  CalendarToday as CalendarTodayIcon,
  AccessTime as AccessTimeIcon,
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
  Warning as WarningIcon,
  Info as InfoIcon,
  Build as BuildIcon,
  Engineering as EngineeringIcon,
  Speed as SpeedIcon,
  Timer as TimerIcon,
  Work as WorkIcon,
  Assignment as AssignmentIcon,
  Inventory as InventoryIcon,
  ProductionQuantityLimits as ProductionQuantityLimitsIcon,
  Category as CategoryIcon,
  Palette as PaletteIcon,
  Straighten as StraightenIcon,
  Scale as ScaleIcon,
  BarChart,
  PieChart,
  ShowChart,
  TableChart,
  InsertChart,
  DataUsage,
  Timeline as TimelineIcon2,
  TrendingUp as TrendingUpIcon2,
  TrendingDown as TrendingDownIcon2,
  Assessment as AssessmentIcon2,
  Analytics as AnalyticsIcon2,
  Receipt as ReceiptIcon2,
  Payment as PaymentIcon2,
  AccountBalance as AccountBalanceIcon2,
  QrCode as QrCodeIcon2,
  Description as DescriptionIcon2,
  Schedule as ScheduleIcon2,
  LocalShipping as LocalShippingIcon2,
  AttachMoney as AttachMoneyIcon2,
  AccountBalanceWallet as AccountBalanceWalletIcon2,
  Security as SecurityIcon2,
  Verified as VerifiedIcon2,
  Lock as LockIcon2,
  Visibility as VisibilityIcon3,
  VisibilityOff as VisibilityOffIcon2,
  Print as PrintIcon2,
  Download as DownloadIcon2,
  Share as ShareIcon2,
  Email as EmailIcon2,
  Phone as PhoneIcon2,
  Business as BusinessIcon2,
  Person as PersonIcon2,
  LocationOn as LocationOnIcon2,
  CalendarToday as CalendarTodayIcon2,
  AccessTime as AccessTimeIcon2,
  TrendingUp as TrendingUpIcon3,
  TrendingDown as TrendingDownIcon3,
  CheckCircle as CheckCircleIcon2,
  Error as ErrorIcon2,
  Warning as WarningIcon2,
  Info as InfoIcon2,
  Build as BuildIcon2,
  Engineering as EngineeringIcon2,
  Speed as SpeedIcon2,
  Timer as TimerIcon2,
  Work as WorkIcon2,
  Assignment as AssignmentIcon2,
  Inventory as InventoryIcon2,
  ProductionQuantityLimits as ProductionQuantityLimitsIcon2,
  Category as CategoryIcon2,
  Palette as PaletteIcon2,
  Straighten as StraightenIcon2,
  Scale as ScaleIcon2,
} from '@mui/icons-material';
import { useRbac } from '../../context/RbacContext';
import { format, parseISO, subDays, startOfDay, endOfDay } from 'date-fns';

interface ReportTemplate {
  id: string;
  name: string;
  type: 'production' | 'financial' | 'quality' | 'inventory' | 'maintenance' | 'custom';
  description: string;
  category: string;
  dataSources: string[];
  parameters: Array<{
    id: string;
    name: string;
    type: 'date' | 'dateRange' | 'select' | 'multiselect' | 'number' | 'text';
    required: boolean;
    defaultValue?: any;
    options?: string[];
  }>;
  charts: Array<{
    id: string;
    type: 'bar' | 'line' | 'pie' | 'table' | 'gauge' | 'scatter';
    title: string;
    dataKey: string;
    config: any;
  }>;
  status: 'active' | 'inactive' | 'draft';
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  schedule?: {
    frequency: 'daily' | 'weekly' | 'monthly' | 'quarterly' | 'yearly';
    time: string;
    recipients: string[];
    enabled: boolean;
  };
}

interface GeneratedReport {
  id: string;
  templateId: string;
  templateName: string;
  parameters: any;
  data: any;
  generatedAt: string;
  generatedBy: string;
  status: 'generating' | 'completed' | 'failed';
  fileUrl?: string;
  fileSize?: number;
  format: 'pdf' | 'excel' | 'csv' | 'html';
}

interface ReportAnalytics {
  totalReports: number;
  reportsThisMonth: number;
  averageGenerationTime: number;
  mostPopularTemplate: string;
  topReportTypes: Array<{
    type: string;
    count: number;
    percentage: number;
  }>;
  generationTrends: Array<{
    date: string;
    reports: number;
    successRate: number;
  }>;
}

export const ReportGenerator: React.FC = () => {
  const { hasPermission } = useRbac();
  const [tabIndex, setTabIndex] = useState(0);
  const [templates, setTemplates] = useState<ReportTemplate[]>([]);
  const [generatedReports, setGeneratedReports] = useState<GeneratedReport[]>([]);
  const [selectedTemplate, setSelectedTemplate] = useState<ReportTemplate | null>(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [editingTemplate, setEditingTemplate] = useState<ReportTemplate | null>(null);
  const [reportParameters, setReportParameters] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filter, setFilter] = useState({
    type: 'all',
    status: 'all',
    category: 'all'
  });
  const [activeStep, setActiveStep] = useState(0);
  const [selectedCharts, setSelectedCharts] = useState<string[]>([]);

  // Mock analytics
  const [analytics, setAnalytics] = useState<ReportAnalytics>({
    totalReports: 0,
    reportsThisMonth: 0,
    averageGenerationTime: 0,
    mostPopularTemplate: '',
    topReportTypes: [],
    generationTrends: []
  });

  // Mock data
  useEffect(() => {
    setTemplates([
      {
        id: '1',
        name: 'Production Performance Report',
        type: 'production',
        description: 'Comprehensive analysis of production metrics and KPIs',
        category: 'operational',
        dataSources: ['production_lines', 'orders', 'quality_checks'],
        parameters: [
          {
            id: '1',
            name: 'Date Range',
            type: 'dateRange',
            required: true
          },
          {
            id: '2',
            name: 'Production Lines',
            type: 'multiselect',
            required: false,
            options: ['Line A', 'Line B', 'Line C', 'Line D']
          },
          {
            id: '3',
            name: 'Metrics',
            type: 'multiselect',
            required: true,
            options: ['Efficiency', 'Quality', 'Output', 'Downtime']
          }
        ],
        charts: [
          {
            id: '1',
            type: 'line',
            title: 'Production Efficiency Over Time',
            dataKey: 'efficiency',
            config: { xAxis: 'date', yAxis: 'percentage' }
          },
          {
            id: '2',
            type: 'bar',
            title: 'Production by Line',
            dataKey: 'production_by_line',
            config: { xAxis: 'line', yAxis: 'units' }
          },
          {
            id: '3',
            type: 'pie',
            title: 'Quality Distribution',
            dataKey: 'quality_distribution',
            config: { valueKey: 'count', nameKey: 'status' }
          }
        ],
        status: 'active',
        createdBy: 'admin@company.com',
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-15T00:00:00Z',
        schedule: {
          frequency: 'weekly',
          time: '09:00',
          recipients: ['manager@company.com', 'supervisor@company.com'],
          enabled: true
        }
      },
      {
        id: '2',
        name: 'Financial Summary Report',
        type: 'financial',
        description: 'Financial performance and revenue analysis',
        category: 'financial',
        dataSources: ['orders', 'payments', 'invoices'],
        parameters: [
          {
            id: '1',
            name: 'Period',
            type: 'select',
            required: true,
            options: ['Daily', 'Weekly', 'Monthly', 'Quarterly', 'Yearly']
          },
          {
            id: '2',
            name: 'Date Range',
            type: 'dateRange',
            required: true
          }
        ],
        charts: [
          {
            id: '1',
            type: 'line',
            title: 'Revenue Trends',
            dataKey: 'revenue',
            config: { xAxis: 'date', yAxis: 'amount' }
          },
          {
            id: '2',
            type: 'bar',
            title: 'Payment Methods',
            dataKey: 'payment_methods',
            config: { xAxis: 'method', yAxis: 'amount' }
          }
        ],
        status: 'active',
        createdBy: 'admin@company.com',
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-15T00:00:00Z'
      },
      {
        id: '3',
        name: 'Quality Control Report',
        type: 'quality',
        description: 'Quality metrics and defect analysis',
        category: 'quality',
        dataSources: ['quality_checks', 'defects', 'inspections'],
        parameters: [
          {
            id: '1',
            name: 'Date Range',
            type: 'dateRange',
            required: true
          },
          {
            id: '2',
            name: 'Quality Categories',
            type: 'multiselect',
            required: false,
            options: ['Visual', 'Functional', 'Measurement', 'Safety']
          }
        ],
        charts: [
          {
            id: '1',
            type: 'pie',
            title: 'Defect Distribution',
            dataKey: 'defect_distribution',
            config: { valueKey: 'count', nameKey: 'type' }
          },
          {
            id: '2',
            type: 'line',
            title: 'Pass Rate Trends',
            dataKey: 'pass_rate',
            config: { xAxis: 'date', yAxis: 'percentage' }
          }
        ],
        status: 'active',
        createdBy: 'admin@company.com',
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-15T00:00:00Z'
      }
    ]);

    setGeneratedReports([
      {
        id: '1',
        templateId: '1',
        templateName: 'Production Performance Report',
        parameters: {
          dateRange: { start: '2024-01-01', end: '2024-01-31' },
          productionLines: ['Line A', 'Line B'],
          metrics: ['Efficiency', 'Quality']
        },
        data: {},
        generatedAt: '2024-01-31T10:00:00Z',
        generatedBy: 'admin@company.com',
        status: 'completed',
        fileUrl: '/reports/production-report-2024-01.pdf',
        fileSize: 2048576,
        format: 'pdf'
      },
      {
        id: '2',
        templateId: '2',
        templateName: 'Financial Summary Report',
        parameters: {
          period: 'Monthly',
          dateRange: { start: '2024-01-01', end: '2024-01-31' }
        },
        data: {},
        generatedAt: '2024-01-31T09:00:00Z',
        generatedBy: 'admin@company.com',
        status: 'completed',
        fileUrl: '/reports/financial-report-2024-01.pdf',
        fileSize: 1536000,
        format: 'pdf'
      }
    ]);
  }, []);

  useEffect(() => {
    // Calculate analytics
    const totalReports = generatedReports.length;
    const reportsThisMonth = generatedReports.filter(report => {
      const reportDate = parseISO(report.generatedAt);
      const startOfMonth = startOfDay(new Date());
      return reportDate >= startOfMonth;
    }).length;

    const reportTypeCounts: Record<string, number> = {};
    generatedReports.forEach(report => {
      const template = templates.find(t => t.id === report.templateId);
      if (template) {
        reportTypeCounts[template.type] = (reportTypeCounts[template.type] || 0) + 1;
      }
    });

    const topReportTypes = Object.entries(reportTypeCounts)
      .map(([type, count]) => ({
        type,
        count,
        percentage: (count / totalReports) * 100
      }))
      .sort((a, b) => b.count - a.count)
      .slice(0, 5);

    setAnalytics({
      totalReports,
      reportsThisMonth,
      averageGenerationTime: 45, // Mock value
      mostPopularTemplate: 'Production Performance Report',
      topReportTypes,
      generationTrends: [
        { date: '2024-01-25', reports: 5, successRate: 100 },
        { date: '2024-01-26', reports: 8, successRate: 87.5 },
        { date: '2024-01-27', reports: 3, successRate: 100 },
        { date: '2024-01-28', reports: 12, successRate: 91.7 },
        { date: '2024-01-29', reports: 7, successRate: 100 }
      ]
    });
  }, [generatedReports, templates]);

  const handleGenerateReport = async (template: ReportTemplate) => {
    try {
      setLoading(true);
      setError(null);

      // Mock report generation
      await new Promise(resolve => setTimeout(resolve, 2000));

      const newReport: GeneratedReport = {
        id: Date.now().toString(),
        templateId: template.id,
        templateName: template.name,
        parameters: reportParameters,
        data: {},
        generatedAt: new Date().toISOString(),
        generatedBy: 'current-user@company.com',
        status: 'completed',
        fileUrl: `/reports/${template.name.toLowerCase().replace(/\s+/g, '-')}-${Date.now()}.pdf`,
        fileSize: Math.floor(Math.random() * 2000000) + 500000,
        format: 'pdf'
      };

      setGeneratedReports(prev => [newReport, ...prev]);
      setSuccess('Report generated successfully');
      setOpenDialog(false);
    } catch (err) {
      setError('Failed to generate report');
    } finally {
      setLoading(false);
    }
  };

  const handleCreateTemplate = () => {
    setEditingTemplate(null);
    setActiveStep(0);
    setSelectedCharts([]);
    setOpenDialog(true);
  };

  const handleEditTemplate = (template: ReportTemplate) => {
    setEditingTemplate(template);
    setSelectedCharts(template.charts.map(c => c.id));
    setActiveStep(0);
    setOpenDialog(true);
  };

  const handleSaveTemplate = async () => {
    try {
      setLoading(true);
      setError(null);

      // Mock API call
      await new Promise(resolve => setTimeout(resolve, 1000));

      setSuccess(editingTemplate ? 'Template updated successfully' : 'Template created successfully');
      setOpenDialog(false);
    } catch (err) {
      setError('Failed to save template');
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadReport = (report: GeneratedReport) => {
    // Mock download
    console.log(`Downloading report: ${report.fileUrl}`);
  };

  const handleScheduleReport = (template: ReportTemplate) => {
    // Mock scheduling
    console.log(`Scheduling report: ${template.name}`);
  };

  const filteredTemplates = templates.filter(template => {
    const matchesSearch = template.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         template.description.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesType = filter.type === 'all' || template.type === filter.type;
    const matchesStatus = filter.status === 'all' || template.status === filter.status;
    const matchesCategory = filter.category === 'all' || template.category === filter.category;
    
    return matchesSearch && matchesType && matchesStatus && matchesCategory;
  });

  const filteredReports = generatedReports.filter(report => {
    return report.templateName.toLowerCase().includes(searchTerm.toLowerCase());
  });

  const renderStatusChip = (status: string) => {
    const color = {
      active: 'success',
      inactive: 'default',
      draft: 'warning'
    }[status];

    return (
      <Chip
        label={status}
        color={color as any}
        size="small"
      />
    );
  };

  const renderTypeChip = (type: string) => {
    const color = {
      production: 'primary',
      financial: 'success',
      quality: 'warning',
      inventory: 'info',
      maintenance: 'secondary',
      custom: 'default'
    }[type];

    return (
      <Chip
        label={type}
        color={color as any}
        size="small"
      />
    );
  };

  const renderReportStatusChip = (status: string) => {
    const color = {
      generating: 'warning',
      completed: 'success',
      failed: 'error'
    }[status];

    return (
      <Chip
        label={status}
        color={color as any}
        size="small"
      />
    );
  };

  const steps = [
    'Template Information',
    'Data Sources & Parameters',
    'Chart Configuration',
    'Schedule & Delivery',
    'Review & Save'
  ];

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <AssessmentIcon color="primary" />
        Report Generator
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {success && (
        <Snackbar
          open={!!success}
          autoHideDuration={6000}
          onClose={() => setSuccess(null)}
        >
          <Alert severity="success" onClose={() => setSuccess(null)}>
            {success}
          </Alert>
        </Snackbar>
      )}

      {/* Analytics Cards */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                Total Reports
              </Typography>
              <Typography variant="h4">
                {analytics.totalReports}
              </Typography>
              <LinearProgress variant="determinate" value={100} sx={{ mt: 1 }} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                This Month
              </Typography>
              <Typography variant="h4" color="primary.main">
                {analytics.reportsThisMonth}
              </Typography>
              <LinearProgress variant="determinate" value={75} sx={{ mt: 1 }} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                Avg Generation Time
              </Typography>
              <Typography variant="h4" color="info.main">
                {analytics.averageGenerationTime}s
              </Typography>
              <LinearProgress variant="determinate" value={60} sx={{ mt: 1 }} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                Success Rate
              </Typography>
              <Typography variant="h4" color="success.main">
                95.2%
              </Typography>
              <LinearProgress variant="determinate" value={95} sx={{ mt: 1 }} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Paper sx={{ width: '100%', mb: 2 }}>
        <Tabs
          value={tabIndex}
          onChange={(_, newValue) => setTabIndex(newValue)}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab label="Report Templates" />
          <Tab label="Generated Reports" />
          <Tab label="Analytics" />
          <Tab label="Scheduled Reports" />
        </Tabs>
      </Paper>

      {tabIndex === 0 && (
        <Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6">Report Templates</Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <TextField
                placeholder="Search templates..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <FormControl size="small" sx={{ minWidth: 120 }}>
                <InputLabel>Type</InputLabel>
                <Select
                  value={filter.type}
                  onChange={(e) => setFilter(prev => ({ ...prev, type: e.target.value }))}
                  label="Type"
                >
                  <MenuItem value="all">All Types</MenuItem>
                  <MenuItem value="production">Production</MenuItem>
                  <MenuItem value="financial">Financial</MenuItem>
                  <MenuItem value="quality">Quality</MenuItem>
                  <MenuItem value="inventory">Inventory</MenuItem>
                  <MenuItem value="maintenance">Maintenance</MenuItem>
                  <MenuItem value="custom">Custom</MenuItem>
                </Select>
              </FormControl>
              <FormControl size="small" sx={{ minWidth: 120 }}>
                <InputLabel>Status</InputLabel>
                <Select
                  value={filter.status}
                  onChange={(e) => setFilter(prev => ({ ...prev, status: e.target.value }))}
                  label="Status"
                >
                  <MenuItem value="all">All Status</MenuItem>
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="inactive">Inactive</MenuItem>
                  <MenuItem value="draft">Draft</MenuItem>
                </Select>
              </FormControl>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={handleCreateTemplate}
                disabled={!hasPermission('reports:template:create')}
              >
                Create Template
              </Button>
            </Box>
          </Box>

          <Grid container spacing={3}>
            {filteredTemplates.map((template) => (
              <Grid item xs={12} md={6} lg={4} key={template.id}>
                <Card>
                  <CardHeader
                    title={template.name}
                    subheader={template.category}
                    action={
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        {renderTypeChip(template.type)}
                        {renderStatusChip(template.status)}
                      </Box>
                    }
                  />
                  <CardContent>
                    <Typography variant="body2" color="textSecondary" gutterBottom>
                      {template.description}
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap' }}>
                      {template.dataSources.map((source, index) => (
                        <Chip key={index} label={source} size="small" variant="outlined" />
                      ))}
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant="caption" color="textSecondary">
                        {template.charts.length} charts
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        {template.parameters.length} parameters
                      </Typography>
                    </Box>
                  </CardContent>
                  <CardActions>
                    <Button
                      size="small"
                      startIcon={<VisibilityIcon />}
                      onClick={() => setSelectedTemplate(template)}
                    >
                      View
                    </Button>
                    <Button
                      size="small"
                      startIcon={<AssessmentIcon />}
                      onClick={() => {
                        setSelectedTemplate(template);
                        setOpenDialog(true);
                      }}
                      disabled={!hasPermission('reports:generate')}
                    >
                      Generate
                    </Button>
                    <Button
                      size="small"
                      startIcon={<EditIcon />}
                      onClick={() => handleEditTemplate(template)}
                      disabled={!hasPermission('reports:template:edit')}
                    >
                      Edit
                    </Button>
                    <Button
                      size="small"
                      startIcon={<ScheduleIcon />}
                      onClick={() => handleScheduleReport(template)}
                      disabled={!hasPermission('reports:schedule')}
                    >
                      Schedule
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      )}

      {tabIndex === 1 && (
        <Box>
          <Typography variant="h6" gutterBottom>
            Generated Reports
          </Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Report Name</TableCell>
                  <TableCell>Generated By</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Format</TableCell>
                  <TableCell>File Size</TableCell>
                  <TableCell>Generated At</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredReports.map((report) => (
                  <TableRow key={report.id} hover>
                    <TableCell>
                      <Typography variant="subtitle2">{report.templateName}</Typography>
                    </TableCell>
                    <TableCell>{report.generatedBy}</TableCell>
                    <TableCell>{renderReportStatusChip(report.status)}</TableCell>
                    <TableCell>
                      <Chip label={report.format.toUpperCase()} size="small" />
                    </TableCell>
                    <TableCell>
                      {report.fileSize ? (report.fileSize / 1024 / 1024).toFixed(2) : '0'} MB
                    </TableCell>
                    <TableCell>
                      {format(parseISO(report.generatedAt), 'MMM dd, yyyy HH:mm')}
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Tooltip title="Download">
                          <IconButton
                            size="small"
                            onClick={() => handleDownloadReport(report)}
                          >
                            <DownloadIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="View">
                          <IconButton size="small">
                            <VisibilityIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Share">
                          <IconButton size="small">
                            <ShareIcon />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}

      {tabIndex === 2 && (
        <Box>
          <Typography variant="h6" gutterBottom>
            Report Analytics
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Card>
                <CardHeader title="Top Report Types" />
                <CardContent>
                  <List>
                    {analytics.topReportTypes.map((type, index) => (
                      <ListItem key={index}>
                        <ListItemText
                          primary={type.type}
                          secondary={`${type.count} reports`}
                        />
                        <ListItemSecondaryAction>
                          <Typography variant="body2" color="primary.main">
                            {type.percentage.toFixed(1)}%
                          </Typography>
                        </ListItemSecondaryAction>
                      </ListItem>
                    ))}
                  </List>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={6}>
              <Card>
                <CardHeader title="Generation Trends" />
                <CardContent>
                  <List>
                    {analytics.generationTrends.map((trend, index) => (
                      <ListItem key={index}>
                        <ListItemText
                          primary={format(parseISO(trend.date), 'MMM dd')}
                          secondary={`${trend.reports} reports`}
                        />
                        <ListItemSecondaryAction>
                          <Typography variant="body2" color="success.main">
                            {trend.successRate}% success
                          </Typography>
                        </ListItemSecondaryAction>
                      </ListItem>
                    ))}
                  </List>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>
      )}

      {tabIndex === 3 && (
        <Box>
          <Typography variant="h6" gutterBottom>
            Scheduled Reports
          </Typography>
          <Card>
            <CardContent>
              <Typography variant="body2" color="textSecondary">
                No scheduled reports found. Create a schedule for automatic report generation.
              </Typography>
            </CardContent>
          </Card>
        </Box>
      )}

      {/* Report Generation Dialog */}
      <Dialog open={openDialog && !!selectedTemplate} onClose={() => setOpenDialog(false)} maxWidth="md" fullWidth>
        {selectedTemplate && (
          <>
            <DialogTitle>
              Generate Report - {selectedTemplate.name}
            </DialogTitle>
            <DialogContent>
              <Typography variant="body1" gutterBottom>
                {selectedTemplate.description}
              </Typography>
              
              <Box sx={{ mt: 2 }}>
                <Typography variant="h6" gutterBottom>
                  Parameters
                </Typography>
                <Grid container spacing={2}>
                  {selectedTemplate.parameters.map((param) => (
                    <Grid item xs={12} md={6} key={param.id}>
                      {param.type === 'dateRange' && (
                        <TextField
                          fullWidth
                          label={param.name}
                          type="date"
                          margin="normal"
                          required={param.required}
                        />
                      )}
                      {param.type === 'select' && (
                        <FormControl fullWidth margin="normal">
                          <InputLabel>{param.name}</InputLabel>
                          <Select
                            label={param.name}
                            required={param.required}
                          >
                            {param.options?.map((option) => (
                              <MenuItem key={option} value={option}>
                                {option}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                      {param.type === 'multiselect' && (
                        <FormControl fullWidth margin="normal">
                          <InputLabel>{param.name}</InputLabel>
                          <Select
                            multiple
                            label={param.name}
                            required={param.required}
                          >
                            {param.options?.map((option) => (
                              <MenuItem key={option} value={option}>
                                {option}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                    </Grid>
                  ))}
                </Grid>
              </Box>

              <Box sx={{ mt: 2 }}>
                <Typography variant="h6" gutterBottom>
                  Output Format
                </Typography>
                <FormControl component="fieldset">
                  <RadioGroup row>
                    <FormControlLabel value="pdf" control={<Radio />} label="PDF" />
                    <FormControlLabel value="excel" control={<Radio />} label="Excel" />
                    <FormControlLabel value="csv" control={<Radio />} label="CSV" />
                    <FormControlLabel value="html" control={<Radio />} label="HTML" />
                  </RadioGroup>
                </FormControl>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenDialog(false)}>
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={() => handleGenerateReport(selectedTemplate)}
                disabled={loading || !hasPermission('reports:generate')}
              >
                {loading ? <CircularProgress size={20} /> : 'Generate Report'}
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>

      {/* Template Details Dialog */}
      <Dialog open={!!selectedTemplate && !openDialog} onClose={() => setSelectedTemplate(null)} maxWidth="md" fullWidth>
        {selectedTemplate && (
          <>
            <DialogTitle>
              {selectedTemplate.name}
            </DialogTitle>
            <DialogContent>
              <Typography variant="body1" gutterBottom>
                {selectedTemplate.description}
              </Typography>
              
              <Box sx={{ mt: 2 }}>
                <Typography variant="h6" gutterBottom>
                  Data Sources
                </Typography>
                <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap' }}>
                  {selectedTemplate.dataSources.map((source, index) => (
                    <Chip key={index} label={source} size="small" />
                  ))}
                </Box>
              </Box>

              <Box sx={{ mt: 2 }}>
                <Typography variant="h6" gutterBottom>
                  Charts
                </Typography>
                <List>
                  {selectedTemplate.charts.map((chart) => (
                    <ListItem key={chart.id}>
                      <ListItemIcon>
                        {chart.type === 'bar' && <BarChart />}
                        {chart.type === 'line' && <ShowChart />}
                        {chart.type === 'pie' && <PieChart />}
                        {chart.type === 'table' && <TableChart />}
                      </ListItemIcon>
                      <ListItemText
                        primary={chart.title}
                        secondary={`Type: ${chart.type}`}
                      />
                    </ListItem>
                  ))}
                </List>
              </Box>

              {selectedTemplate.schedule && (
                <Box sx={{ mt: 2 }}>
                  <Typography variant="h6" gutterBottom>
                    Schedule
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {selectedTemplate.schedule.frequency} at {selectedTemplate.schedule.time}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Recipients: {selectedTemplate.schedule.recipients.join(', ')}
                  </Typography>
                </Box>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setSelectedTemplate(null)}>
                Close
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  setOpenDialog(true);
                }}
                disabled={!hasPermission('reports:generate')}
              >
                Generate Report
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </Box>
  );
};
